'use strict';

export default class BasePreprocessor {
	constructor() {
		Object.defineProperties(this, {
			changedHandlers: {
				writable: true,
				enumerable: true,
				value: [],
			},
		});
	}

	addChangedHandler(handler) {
		if (typeof handler === 'function') {
			this.changedHandlers.push(handler);
		}
	}

	changed() {
		this.changedHandlers.forEach(function (handler) {
			handler();
		});
	}

	init() {
		//to init default values from attributes
	}

	initPersonalization() {
		//to load personalization values.
	}
}
